import img1 from "../images/imagesHome/HomePage/HomeScreenImages/shadnagar_5k-1.webp";
import img2 from "../images/imagesHome/HomePage/HomeScreenImages/high_res_work_area.webp";
import img3 from "../images/imagesHome/HomePage/HomeScreenImages/Hirakud-24jul17-C2S.webp";
import img4 from "../images/imagesHome/HomePage/HomeScreenImages/Irrigation.webp";
import img5 from "../images/imagesHome/HomePage/HomeScreenImages/jamui_bihar_3k-2.webp";

export default {
  items: [
    {
      id:3 ,
      caption:"NRSC",
      img: img1,
      
      description:"National Remote Sensing Centre (NRSC) is one of the primary centres of Indian Space Research Organisation (ISRO), Department of Space (DOS). ",
      ref: "http://www.nrsc.gov.in"
    },

    {
      id:1 ,
      img: img2,
      caption:"ISRO",
      description:"Indian Space Research Organisation (ISRO) is the space agency of India. The organisation is involved in science, engineering and technology to harvest the benefits of outer space for India and the mankind. ISRO is a major constituent of the Department of Space (DOS), Government of India. The department executes the Indian Space Programmeprimarily through various Centres or units within ISRO.",
      ref: "http://www.isro.gov.in" 
    
    },

    {
      id:2 ,
      img: img3,
      caption:"BHUVAN NHP",
      description:"National Remote Sensing Centre (NRSC) is chosen as one of the Central Implementing Agency (IA) under NHP to provide satellite data based hydrological products & services. As part of this, NRSC is undertaking generation of geo-spatial products & services pertaining to water resources sector, development of flood early warning systems, and decision support system development for irrigation water management...",
       ref: "https://bhuvan.nrsc.gov.in/nhp/"
      
    },
    {
      id:4,
      img: img4,
      caption:"BHUVAN",
      description:"National Remote functioning Sensing Agency (NRSA)",
      ref: "https://bhuvan.nrsc.gov.in"
    },
    {
      id: 5,
      img: img5,
      caption:"Bhuvan",
      description:"National Remning as an autonomous body called National Remote Sensing Agency (NRSA)",
      ref: "https://bhuvan.nrsc.gov.in"
    },
  ],
};
